import { down, up } from "styled-breakpoints";
import styled from "styled-components";

export const Wrapper = styled.footer`
  position: relative;
  overflow: hidden;
  padding: 58px 0 0;
  background: linear-gradient(rgb(249, 250, 252) -16.43%, rgb(255, 255, 255) 87.01%, rgb(255, 255, 255) 87.01%, rgb(255 255 255) 87.01%);
  color: #626b65;
  .footer-content {
    position: relative;
    padding-bottom: 90px;
    ${up("md")}{
      padding-bottom: 130px;
    }
    z-index: 1;
  }

  .footer-primary {
    display: grid;
    grid-template-columns: minmax(240px, 1.65fr) minmax(0, 2fr);
    gap: 60px;
    padding-bottom: 40px;
  }

  .footer-brand {
    img {
      width: 114px;
      height: auto;
    }

    p {
      max-width: 355px;
      margin: 22px 0 0;
      font-size: 14px;
      line-height: 1.7;
    }
  }

  .footer-links {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;

    section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      strong {
        margin-bottom: 5px;
        color: #505852;
        font-size: 14px;
        font-weight: 600;
      }

      a,
      .footer-link {
        padding: 0;
        border: 0;
        background: transparent;
        color: #68716b;
        font-size: 14px;
        line-height: 1.25;
        text-decoration: none;
        text-align: left;
        cursor: pointer;

        &:hover {
          color: #079c16;
        }
      }
    }
  }

  .footer-bottom {
    display: flex;
    align-items: center;
    gap: 30px;
    min-height: 66px;
    border-top: 1px solid #e9eeea;

    p,
    a {
      margin: 0;
      color: #6d756f;
      font-size: 13px;
      text-decoration: none;
    }

    .footer-legal {
      display: flex;
      flex-wrap: wrap;
      gap: 22px;
    }

    .footer-socials {
      display: flex;
      gap: 9px;
      margin-left: auto;

      a {
        display: grid;
        place-items: center;
        width: 33px;
        height: 33px;
        border: 1px solid #dde4de;
        border-radius: 8px;
        color: #56615a;

        svg {
          width: 15px;
          height: 15px;
        }

        &:hover {
          border-color: #079c16;
          color: #079c16;
        }
      }
    }
  }

  .footer-watermark {
    position: absolute;
    right: 0;
    bottom: -150px;
    left: 0;
    z-index: 0;
    color: rgba(234, 237, 241, 0.4);
    font-family: "Kamerik 205", sans-serif;
    font-size: clamp(132px, 21vw, 350px);
    font-weight: 700;
    letter-spacing: -0.05em;
    line-height: 0.86;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    ${down("xl")}{
      bottom: -50px;
    }
    ${down("md")}{
      bottom: -15px;
      font-size: clamp(100px, 22vw, 250px);
    }
  }

  @media (max-width: 991px) {
    .footer-primary {
      grid-template-columns: 1fr;
      gap: 42px;
    }
  }

  @media (max-width: 767px) {
    .footer-links {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      row-gap: 30px;
    }

    .footer-bottom {
      align-items: flex-start;
      flex-direction: column;
      gap: 18px;
      padding: 24px 0;

      .footer-socials {
        margin-left: 0;
      }
    }
  }

  @media (max-width: 575px) {
    padding-top: 46px;

    .footer-primary {
      gap: 36px;
      padding-bottom: 34px;
    }

    .footer-brand p {
      font-size: 13px;
    }

    .footer-links section {
      gap: 10px;

      strong,
      a {
        font-size: 13px;
      }
    }

    .footer-legal {
      gap: 14px !important;
    }
  }
`;
